exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\r\n  color: aliceblue;\r\n}\r\n\r\n.size-image {\r\n  width: 70vh;\r\n  height: auto;\r\n}\r\n\r\n.carousel {\r\n  background: #808080;\r\n  margin-top: 20px;\r\n}\r\n\r\n.carousel .item {\r\n  min-height: 280px;\r\n  /* Prevent carousel from being distorted if for some reason image doesn't load */\r\n}\r\n\r\n.carousel .item img {\r\n  margin: 0 auto;\r\n  max-width: 400px;\r\n  /* Align slide image horizontally center */\r\n}\r\n\r\n.bs-example {\r\n  margin: 20px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/app/pages/home/home.component.css
// module id = ../../../../../src/app/pages/home/home.component.css
// module chunks = main